// extracted by mini-css-extract-plugin
module.exports = {"successMessage":"SuccessMessage_successMessage__1sGUt"};